import Vue from 'vue'
import * as VueGoogleMaps from 'gmap-vue'
import App from './App.vue'

Vue.config.productionTip = false

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyDJv_SVXAvMQ2vbg8dsr3VCjpDVW0mgtVU',
    libraries: 'places',
  }
});

new Vue({
  render: h => h(App),
}).$mount('#app')
